module.exports = "<div class=\"footer\">\n\t© 2019 Connect Assistance, LLC. All Rights Reserved.\n</div>\n"